<template>
    <div :class="columnclass">
        <div :class="[inputwrapperclass, addclass, {error: errors.has(name)}]">
            <div class="form-label" :class="labelclass" v-if="label">
                {{ label }}
                <template v-if="required">*</template>
            </div>
            <div class="input-group">
              <div class="input-group-prepend" v-if="prepend">
                <span class="input-group-text">{{ prepend }}</span>
              </div>
              <input class="form-control" v-model="val" @input="input" :type="type" :placeholder="placeholder" :required="required" :disabled="disabled" :autocomplete="autocomplete">
              <div class="input-group-append" v-if="append">
                <span class="input-group-text">{{ append }}</span>
              </div>
            </div>
            <span v-if="errors.has(name)" class="error-msg">{{ errors.get(name) }}</span>
        </div>
    </div>
</template>

<script>

export default {
  inject: [
    'errors'
  ],
  props: {
    value: {
      required: true
    },
    label: {
      required: false,
      default: null
    },
    name: {
      required: true
    },
    columnclass: {
      default: 'col-lg-6 col-12'
    },
    inputwrapperclass: {
      default: 'input-wrapper'
    },
    addclass: {
      default: ''
    },
    labelclass: {
      default: ''
    },
    placeholder: {
      default: null
    },
    type: {
      default: 'text'
    },
    required: {
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    prepend: {
      type: String,
      default: null
    },
    append: {
      type: String,
      default: null
    },
    autocomplete: {
      default: null,
      type: String,
      validator: function (value) {
        return ['off', 'new-password'].indexOf(value) !== -1
      }
    }
  },
  data () {
    return {
      val: this.value
    }
  },
  methods: {
    input () {
      this.$emit('input', this.val)
    }
  }
}
</script>

<style lang="scss" scoped>
    .input-wrapper {
        &.error {
            input {
                border-color: #c2063b;
            }
        }

        .error-msg {
            color: #c2063b;
        }
    }
    .form-label {
      &.text-normal {
        font-weight: normal !important;
      }
    }
</style>
